"use client";

import React, { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
import { FaBullseye, FaEye ,FaHandshake} from "react-icons/fa";


export default function AboutPage() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.3 });
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (isInView) {
      setKey((prev) => prev + 1); 
    }
  }, [isInView]);

  const cards = [
    {
      title: "Vision Statement",
      text: "To be the leading event solutions provider, creating unforgettable experiences that inspire, connect, and leave lasting impressions.",
      icon: <FaEye className="text-4xl text-black" />,
    },
    {
      title: "Mission Statement",
      text: "Our mission is to bring our clients visions to life by delivering seamless, innovative, and personalized event experiences. We are committed to excellence, creativity, and client satisfaction — from concept to execution.",
      icon: <FaBullseye className="text-4xl text-black" />,
    },
    {
      title: "Value",
      text: "Excellence, Creativity, Collaboration, and Innovation.",
      icon: <FaHandshake className="text-4xl text-black" />,
      
    },
  ];

  return (
    <main
      ref={sectionRef}
      className="w-full flex flex-col items-center justify-center bg-white dark:from-gray-900 dark:to-black p-8"
    >
      <motion.h1
        key={`title-${key}`}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="font-bebas text-4xl md:text-6xl text-center bg-black bg-clip-text text-transparent mb-8"
      >
        About Us
      </motion.h1>

      <motion.p
        key={`desc-${key}`}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
        className="max-w-2xl text-center text-lg text-gray-600 dark:text-gray-300 mb-12"
      >
      We are a 100% based Omani company and very passionate about
event management as we take each one very personally. Our passion
and dedication, combined with the experience of our in-house event
specialists enables us to exceed client expectations
      </motion.p>

      <motion.div
        key={`cards-${key}`}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl"
      >
        {cards.map((card, i) => (
          <div
            key={i}
            className="p-6 rounded-xl bg-white shadow-lg flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300"
          >
            <motion.div whileHover={{ scale: 1.2 }} className="mb-4">
              {card.icon}
            </motion.div>
            <h3 className="text-2xl font-bebas mb-2 text-black">
              {card.title}
            </h3>
            <p className="text-gray-500 dark:text-gray-400">{card.text}</p>
          </div>
        ))}
      </motion.div>
    </main>
  );
}
